import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'

import { useAuthStore, useEchoStore } from '@/stores/stores'
import {
  LoginPage,
  DashboardPage,
  ScreensPage,
  MediaPage,
  PlaylistsPage,
  AlertsPage,
  StatisticsPage,
} from './pages/Pages'
import {
  SchedulesPage,
  TickersPage,
  StreamsPage,
  SettingsPage,
} from './pages/SettingsPages'
import { ApiKeysPage } from './pages/ApiKeysPage.jsx'
import { WebhooksPage } from './pages/WebhooksPage.jsx'
import { TenantsPage, UsersPage, SystemPage } from './pages/AdminPages.jsx'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      retry: 1,
    },
  },
})

// ── Protected route ─────────────────────────────────────────
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore()
  if (!isAuthenticated()) return <Navigate to="/login" replace />
  return children
}

// ── WebSocket inicializace po přihlášení ─────────────────────
function EchoInit() {
  const { token } = useAuthStore()
  const { init }  = useEchoStore()
  useEffect(() => { if (token) init(token) }, [token])
  return null
}

// ── App ──────────────────────────────────────────────────────
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/admin">
        <EchoInit />
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard"  element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/screens"    element={<ProtectedRoute><ScreensPage /></ProtectedRoute>} />
          <Route path="/media"      element={<ProtectedRoute><MediaPage /></ProtectedRoute>} />
          <Route path="/playlists"  element={<ProtectedRoute><PlaylistsPage /></ProtectedRoute>} />
          <Route path="/schedules"  element={<ProtectedRoute><SchedulesPage /></ProtectedRoute>} />
          <Route path="/tickers"    element={<ProtectedRoute><TickersPage /></ProtectedRoute>} />
          <Route path="/streams"    element={<ProtectedRoute><StreamsPage /></ProtectedRoute>} />
          <Route path="/alerts"     element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
          <Route path="/statistics" element={<ProtectedRoute><StatisticsPage /></ProtectedRoute>} />
          <Route path="/settings"   element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

          <Route path="/api-keys"   element={<ProtectedRoute><ApiKeysPage /></ProtectedRoute>} />
          <Route path="/webhooks"   element={<ProtectedRoute><WebhooksPage /></ProtectedRoute>} />
          <Route path="/tenants"    element={<ProtectedRoute><TenantsPage /></ProtectedRoute>} />
          <Route path="/users"      element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          <Route path="/system"     element={<ProtectedRoute><SystemPage /></ProtectedRoute>} />
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
